import { useOpenModal } from 'utils/modals';

import { ReportTalentModalData } from './types';
import { REPORT_TALENT_MODAL_ID } from './types';

export const useOpenReportTalentModal = () =>
  useOpenModal<ReportTalentModalData>(REPORT_TALENT_MODAL_ID);

